import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { TAIL_SIZE } from './utils/consts';

type OpenXAgentGreetingCardProps = {
  userName: string;
};

export const OpenXAgentGreetingCard = ({ userName }: OpenXAgentGreetingCardProps) => {
  const { t } = useTranslation();

  return (
    <Box
      data-test="openx-agent-greeting-card"
      sx={{
        position: 'relative',
        alignSelf: 'flex-start',
        ml: `${TAIL_SIZE}px`,
        px: 2,
        pt: 2.5,
        pb: 2,
        backgroundColor: 'background.boxDark',
        borderRadius: '4px 4px 4px 0',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: -TAIL_SIZE,
          bottom: 0,
          borderStyle: 'solid',
          borderWidth: `0 0 ${TAIL_SIZE}px ${TAIL_SIZE}px`,
          borderColor: 'transparent',
          borderBottomColor: 'background.boxDark',
        },
      }}
    >
      <Typography
        variant="h3"
        component="p"
        sx={{ m: 0, fontSize: 16, lineHeight: '22px', fontWeight: 'fontWeightMedium', color: 'text.primary' }}
      >
        {t('Hi {name}!', { name: userName })}
      </Typography>
      <Typography sx={{ mt: 1.5, fontSize: 14, lineHeight: '20px', color: 'text.primary' }}>
        {t('What are we working on today?')}
      </Typography>
    </Box>
  );
};
